<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="panel panel-primary">
                    <div class="panel-heading">
                        <h3>Ordenar Material Promocional</h3>
                    </div>
                    <div class="panel-body">
                        <div class="row" v-if="!order">
                            <div class="col-md-8">
                                <div class="form-group">
                                    <label for="promotional">Material Promocional</label>
                                    <select name="promotional[]" id="promotional" v-model="ordered" size="8" multiple>
                                        <option :value="index" v-for="(promotional, index) in promotional">
                                            {{ promotional.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-12 m-t-sm">
                                <button class="btn btn-primary" @click="setPromotionalMaterials">Ordenar Material
                                    Promocional <i class="fa fa-shopping-bag"></i></button>
                            </div>
                        </div>

                        <div class="row" v-if="order">
                            <div class="col-md-12">
                                <draggable v-model="selected" :list="selected" class="dragArea">
                                    <li v-for='(promotional,index) in selected' :key="promotional.id"
                                        class="list-group-item clearfix draggable">
                                        <i class="mdi mdi-drag pull-left"></i>
                                        <i class="pull-left fa fa-2x fa-arrows-v align-middle"></i>
                                        <span class="stages" :id="'stage' + promotional.id">{{ index + 1 }}. {{ promotional.name }} </span>
                                        <button class="btn btn-danger pull-right" @click="remove(promotional, index)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </li>
                                </draggable>
                            </div>
                            <div class="col-md-12 m-t-md">
                                <button class="btn btn-info" @click="back"><i class="fa fa-arrow-left"></i> Voltar
                                </button>
                                <button class="btn btn-success" @click="save" style="margin-left:3px;">Salvar Ordenação
                                    <i class="fa fa-save"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';

    export default {
        data: function () {
            return {
                promotional: [],
                selected: [],
                ordered: [],
                order: false
            }
        },
        components: {
            draggable
        },
        methods: {
            getPromotionalMaterialsArray: function (data) {
                let array = [];
                $.each(data, function (index, value) {
                    if (value.sort_by) {
                        array.push(index);
                    }
                });
                return array;
            },
            getPromotionalMaterials: function () {
                let self = this;
                let api = self.$store.state.api + 'promotional?paginated=false';
                let promotional = $('#promotional');

                self.$http.get(api)
                    .then((response) => {
                        self.promotional = response.data.data;
                        self.ordered = self.getPromotionalMaterialsArray(self.promotional);
                    })
                    .then(() => {
                        promotional.bootstrapDualListbox();
                        promotional.ready(function () {
                            promotional.bootstrapDualListbox('refresh', true);
                        });
                    })
                    .catch((error) => {
                        self.$message(null, 'Ocorreu um erro ao buscar os Promotional Materials', 'error');
                    });
            },
            setPromotionalMaterials: function () {
                const self = this;
                let promotional = self.selected;

                $('#promotional').find(':selected').each(function () {
                    promotional.push(self.promotional[$(this).val()]);
                });

                self.selected = promotional;
                self.order = true;
            },
            save: function () {
                const self = this;
                const api = self.$store.state.api + 'promotional/update/multiple';
                let selected = [];

                $.each(self.selected, function (index, value) {
                    selected.push({
                        id: value.id,
                        sort_by: (index + 1)
                    });
                });

                self.$http
                    .post(api, {materials: selected})
                    .then((response) => {
                        self.$message(null, 'Ordenação salva com sucesso', 'success');
                    })
                    .catch((error) => {
                        self.$error('Não foi possível atualizar os registros');
                    });

                self.ordered = self.getPromotionalMaterialsArray(self.selected);
            },
            remove: function (promotional, index) {
                const self = this;
                const api = self.$store.state.api + 'promotional/' + promotional.id;

                let array = [];
                $.each(self.selected, function (key, value) {
                    if (index !== key) {
                        array.push(value);
                    }
                });

                self.$http.put(api, {
                    sort_by: null
                })
                    .then((response) => {
                        this.selected = array;
                    });
            },
            back: function () {
                window.location.reload();
            }
        },
        mounted: function () {
            this.getPromotionalMaterials();
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/PromotionalOrder/Index.vue